export default __webpack_public_path__ + "static/media/growing-up-woman.a1585842.svg";